import { internalApiClient } from "../config/internalApiClient";

export type SellPayload = {
  productId: string;
  quantity: number;
  amount: number;
  operation: "SELL";

  fullName: string;
  phone: string;

  gstNumber?: string;
  upiId?: string;
  bankDetails?: string;
  paymentQrCode?: string;
};

export const sellService = {
  sellProduct: async (payload: SellPayload): Promise<unknown> => {
    try {
      const response = await internalApiClient.post(
        "/api/sell",
        payload,
        {
          toast: {
            successMessage: "Sell request submitted successfully.",
            errorMessage: "Failed to submit sell request. Please try again.",
          },
        }
      );
      return response.data;
    } catch (e) {
      console.error("sellProduct error:", e);
      throw e;
    }
  },
};
